import { DiversityIcon, EngagementIcon, InnovationIcon, TransparenceIcon } from "../assets";

import Lottie from "lottie-react";
import animation_data_transparent from "../assets/logo-wall-of-share-.json";

import '../styles/additional.css';
import { RoundBluePlain } from "../components/ui/Buttons/generic/GenericButton";
import { FooterMaximized } from "../components/footerfull";
import Header from "../components/headerfull";
import { useEffect } from "react";
import UniversitiesSlider from "../components/universitySlider/UniversitiesSlider";

import UNIS from '../assets/UNIS.json';
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function AboutUs(){

    useEffect(()=> {
        document.title= "À propos de Wall of Share - Notre mission";
        const desc= "Découvrez comment Wall of Share brise les barrières géographiques et dynamise le marché du travail entre freelance et d’entreprise.";
        setDescription(desc);
    }, []);
    
    useGSAP(() => {
        gsap.from('.enter-right', {
            opacity: 0,
            x: 100,
            duration: 0.7,
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.enter-right-trigerrer',
                start: 'top center',
                end: 'bottom center',
                scrub: false,
                toggleActions: 'play none play reverse',
                markers: false
            },
        });
    });

    let isFreelance = true;
    return (
        <div className="max-w-[100vw] overflow-x-clip">
            <Header type="default" />

            <HeroBanner/>

            <OurValue />

            <div className="m-auto lg:w-1/2 w-5/6 py-[140px] pb-[153px] flex flex-col items-center gap-10 md:min-w-[650px]">
                <div className="flex flex-col justify-center md:text-center max-w-[714.5px]">
                    <h2 className="text-h2 text-primary-blue font-semibold mb-3 enter-right-trigerrer ">Rencontrez notre équipe</h2>
                    <p className="text-[1.25rem] text-[#656565] font-dm-sans">Le succès de Wall Of Share repose sur une équipe passionnée et innovante. Découvrez les leaders qui guident notre mission :</p>
                </div>
                <div className="flex flex-col md:flex-row gap-5 max-w-[714.5px]">
                    <TeamMember avatar={"/about-images/william.webp"} nom="William Cohen" profession="CEO FOUNDER"/>
                    <TeamMember avatar={"/about-images/noam.webp"} nom="Noam Dahan" profession="CO-FOUNDER"/>
                </div>
            </div>

            <div className="lg:w-3/4 w-5/6 max-w-[1071px] m-auto bg-[#1D1D39] relative py-16 md:px-[6rem] px-[1.8em] rounded-3xl my-6">
                <div className="text-white font-semibold text-[22px]">“Rejoindre Wall Of Share a été une véritable opportunité pour moi. Grâce à cette&nbsp;plateforme, j'ai pu décrocher un poste au sein d'une entreprise française qui&nbsp;correspond parfaitement à mes aspirations professionnelles !”</div>
                
                <div className="mt-4 flex md:flex-row md:gap-3 flex-col">
                  <div className="text-[18px] lg:font-semibold text-white">Maimouna Ndiaye</div>
                  <div className="text-[#BBBBC499] lg:font-normal">Assistante comptable freelance</div>
                </div>
                <img src="/images/flyer.png" alt="flyer" className="w-[11rem] absolute right-0 z-20 top-[2em] hidden md:block"/>
            </div>

            <Spacer/>{/* <-- Need space ? I'm here to help ;D */}

            <div className="w-full py-[9rem] bg-[#F4F4F599] relative pb-[32rem] lg:pb-[20rem] ">
                <OurStory />
                <CallToAction isFreelance={isFreelance} />
            </div>

            <UniversitiesSlider UNIS={UNIS} bigMargin={true}/>

            <FooterMaximized />
        </div>
    );
}


export const TeamMember = ({avatar,nom="Nom Prénom",profession="Profession"}:any)=>{
    return (
        <div className="bg-gray-200  w-full  flex rounded-2xl p-4 space-x-4 h-[8rem] items-center px-6 enter-right">
            <div className="roundImage">
                <img src={avatar} alt="avatar 1" className="h-[6rem]"  />
            </div>
            <div>
                <div className="font-semibold text-primary-blue text-[22px] leading-[28.64px] font-dm-sans">{nom}</div>
                <div className="font-light text-[#656565] font-dm-sans">{profession}</div>
            </div>
        </div>
    )
}

const HeroBanner= () => {
    useGSAP(() => {
        gsap.from('.slide-from-left', {
            opacity: 0,
            x: 150,
            duration: 0.7,
            scrollTrigger: {
                trigger: '.slide-side-triggerer',
                start: 'top center',
                end: 'bottom center',
                scrub: false,
                toggleActions: 'play none play reverse',
                markers: false
            },
        });
        gsap.from('.slide-from-right', {
            opacity: 0,
            x: -150,
            duration: 0.7,
            scrollTrigger: {
                trigger: '.slide-side-triggerer',
                start: 'top center',
                end: 'bottom center',
                scrub: false,
                toggleActions: 'play none play reverse',
                markers: false
            },
        });
    });
    return <>
        <div id="hero-banner" className="w-full bg-primary-blue md:h-[610px] h-[410px] relative bg-cover bg-center " style={{backgroundImage: `url('/about-images/about-banner.webp')`}}>
            <div className="absolute top-[50%] left-[50%] transform translate-x-[-50%] translate-y-[-50%] flex flex-col items-center max-w-[915px] w-5/6 ">
                <div className="lottie-container md:max-w-[25rem] max-w-[18rem] relative max-h-[8rem] w-full md:h-[8rem] h-[6.5rem]">
                    <Lottie animationData={animation_data_transparent} loop= {true} style={{background: "transparent"}} className="absolute top-[50%] left-0 transform translate-y-[-50%] w-full"/>
                </div>
                {/* <img src={Logo2x} alt="wos-logo" className={"mb-4"}/> */}
                <h1 id="title" className="text-white font-semibold md:text-[34px] md:leading-[40px] text-[20px] leading-[24px] text-center">Transformez votre recrutement avec <span className='text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 border-2 border-transparent p-[2px]'> Wall Of Share</span>, votre partenaire global pour des talents exceptionnels.</h1>
            </div>
        </div>
        <div className="w-full slide-side-triggerer">
            <div className="grid lg:grid-cols-[22fr_40fr] grid-cols-[1fr] lg:w-3/4 w-5/6 max-w-[1071px] m-auto md:gap-[5rem] md:py-[8rem] py-[80px] place-items-start gap-[2.5rem]">
                <h2 className="text-h2 text-primary-blue font-semibold slide-from-right">Réinventer le recrutement pour un&nbsp;avenir meilleur</h2>
                <div id="banner-paragraph" className="font-normal md:text-[22px] md:leading-[28.64px] text-[18px]  text-[#656565] font-dm-sans slide-from-left">
                    <p>Chez Wall Of Share, notre engagement est de transformer le monde du travail en facilitant des connexions précieuses entre des professionnels talentueux et des entreprises en pleine croissance. Nous croyons que chaque interaction sur notre plateforme peut être une opportunité pour une carrière enrichissante et une croissance organisationnelle.</p>
                </div>
            </div>
        </div>
    </>;
};

const Spacer= () => {
    return <div className="my-10 py-5" ></div>;
};

const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
};

export function OurValue() {//<-Also used in the home page so why not ?
    useGSAP(() => {
        gsap.from('.slide-up', {
            opacity: 0,
            y: 50,
            duration: 1,
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.slide-up-triggerer',
                start: 'top 80%',
                end: 'bottom center',
                scrub: false,
                toggleActions: 'play none play reverse',
                markers: false
            },
        });
    });
    return (
        <>
            <div className="lg:w-3/4 w-5/6 m-auto max-w-[1144px] slide-up-triggerer">
                <div className="flex flex-col lg:flex-row gap-[5rem] text-[#656565]">
                    <div className="w-full rounded-3xl relative overflow-hidden min-h-[23rem] bg-norepeat bg-center bg-cover" style={{ backgroundImage: `url('/about-images/about-01.webp')` }}>
                    </div>

                    <div className="mx-0">
                        <div className="text-[27px] leading-[35.15px] font-semibold 2xl:pr-[8rem] text-primary-blue slide-up"><h3>Les valeurs qui nous guident sont au cœur de notre approche et de notre culture :</h3></div>

                        <div className="flex flex-col gap-[2em] my-8">
                            <div className="flex flex-col slide-up">
                                <div className="flex space-x-4 items-center text-[25px] leading-[30px] font-semibold text-primary-blue">
                                    <img src={InnovationIcon} alt="innovation" />
                                    <div>Innovation</div>
                                </div>
                                <p className="my-3 font-normal text-[18px] leading-[23.44px] font-dm-sans">Toujours à la pointe pour offrir des solutions de recrutement innovantes et efficaces, répondant aux besoins spécifiques de chaque entreprise.</p>
                            </div>

                            <div className="flex flex-col slide-up">
                                <div className="flex space-x-4 items-center text-[25px] leading-[30px] font-semibold text-primary-blue">
                                    <img src={TransparenceIcon} alt="transparence" />
                                    <div>Transparence</div>
                                </div>
                                <p className="my-3 font-normal text-[18px] leading-[23.44px] font-dm-sans">Cultiver la confiance grâce à des pratiques honnêtes, ouvertes et transparentes, assurant une collaboration claire et fluide.</p>
                            </div>

                            <div className="flex flex-col slide-up">
                                <div className="flex space-x-4 items-center text-[25px] leading-[30px] font-semibold text-primary-blue">
                                    <img src={EngagementIcon} alt="engagement" />
                                    <div>Engagement</div>
                                </div>
                                <p className="my-3 font-normal text-[18px] leading-[23.44px] font-dm-sans">Enregistrez votre entreprise et commencez à recruter en quelques minutes, avec un accompagnement constant pour garantir votre succès.</p>
                            </div>

                            <div className="flex flex-col slide-up">
                                <div className="flex space-x-4 items-center text-[25px] leading-[30px] font-semibold text-primary-blue">
                                    <img src={DiversityIcon} alt="engagement" />
                                    <div>Diversité</div>
                                </div>
                                <p className="my-3 font-normal text-[18px] leading-[23.44px] font-dm-sans">Valoriser la richesse des compétences et des perspectives pour créer des équipes solides et performantes.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const OurStory = () => {
    return (
        <div className="lg:w-3/4 w-5/6 max-w-[1071px] mx-auto md:grid md:grid-cols-[1fr_1fr] flex flex-col-reverse lg:gap-[6.5em] md:gap-[3em] gap-[2.4em]">
            <div id="our-story" className="flex flex-col gap-[1.5em] text-[1.18rem] text-[#656565]">
                <h2 className="text-h2 font-semibold text-primary-blue mb-2">L'histoire de Wall of Share</h2>
                <p className="font-dm-sans">Wall of Shares est né d'un besoin réel. En tant que groupe, RESELFORM a mené, pendant plus de quatre ans, de nombreux projets ambitieux en développement web, création de CRM et campagnes publicitaires. Pour nous soutenir, nous avons testé plusieurs plateformes freelance comme Malt, Fiverr et Upwork. Mais ces solutions présentaient une limite: les prestataires, souvent surchargés de missions concurrentes, n'étaient pas en mesure de garantir les délais et la disponibilité dont nous avions besoin.
                </p>
                <p className="font-dm-sans">En 2022, nous avons décidé d'aller plus loin : cap sur Dakar, Sénégal. C'est là que nous avons fondé RESELFORM DAKAR et recruté notre première équipe sur place, passant de 10 à 40 employés en un an. </p>

                <div className="bg-gray-200 p-4 px-6 rounded-xl text-primary-blue font-dm-sans">
                    <p style={{ textDecoration: "underline" }} className="font-dm-sans">Cette expérience a fait émerger une idée :</p>
                    <p className="font-dm-sans">Et si nous créions une plateforme pour connecter entreprises et talents dans les pays émergents, mais sur un modèle innovant ?</p>
                </div>
                <p className="font-dm-sans">C'est ainsi que Wall of Shares a vu le jour en 2023. Notre concept ? <span className="font-semibold">Proposer aux entreprises un modèle de collaboration sécurisé et durable.</span> Les talents affichent la rémunération mensuelle qui leur permet de se consacrer pleinement à leurs missions, et les entreprises obtiennent un engagement de qualité sans le risque de voir leurs projets retardés par d'autres contrats.</p>
                <p className="font-dm-sans">La plateforme Wall of Share offre également une expérience fluide avec des outils intégrés : une messagerie semblable à WhatsApp, un gestionnaire de projets inspiré de Trello, un calendrier connecté et des feuilles de temps pour suivre le travail. En plus, un interlocuteur français dédié accompagne chaque client pour simplifier le processus et assurer des transferts financiers fiables.</p>
                <p className="font-semibold text-primary-blue font-dm-sans">C'est avec cette vision de transparence et de sécurité que Wall of Share est devenu le partenaire de confiance pour les entreprises et les talents de demain.</p>
            </div>
            <div className="relative">
                <img src={"/about-images/about-02.webp"} alt="Professionals talking business casually" className="md:sticky rounded-3xl md:top-[40px]" />
            </div>
        </div>
    );
}

export const CallToAction = ({isFreelance, isAbsolute= true}: {isFreelance: boolean, isAbsolute?: boolean}) => {//<- isFreelance is inverted and does the opposite of what we would expect it to do. Need to be fixed later.
    useGSAP(() => {
        gsap.from('.cta-slide-from-bottom', {
            opacity: 0,
            y: 80,
            duration: 0.7,
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.cta-slide-from-bottom',
                start: 'top 80%',
                end: 'bottom center',
                scrub: false,
                toggleActions: 'play none play none',
                markers: false
            },
        });
        gsap.from('.slide-up-triggerer-2', {
            opacity: 0,
            x: 100,
            duration: 0.7,
            stagger: 0.2,
            scrollTrigger: {
                trigger: '.slide-up-triggerer-2',
                start: 'top 80%',
                end: 'bottom center',
                scrub: false,
                toggleActions: 'play none play reverse',
                markers: false
            },
        });
    });
    let cName= !isFreelance? 'slide-up-triggerer-2  bg-[#F4F4F5]' : 'slide-up-triggerer-2  bg-primary-blue';
    cName+= " rounded-3xl flex justify-center lg:w-3/4 w-5/6 max-w-[1071px] mx-auto lg:px-[6.2em] px-[2em] py-14 lg:min-w-[900px]";
    cName+= isAbsolute ? " absolute bottom-0 left-[50%] transform md:translate-y-[50%] translate-y-[65%] translate-x-[-50%]" : "";
    return (
        <div className={cName}>
            <div className=" flex gap-[3em] flex-col lg:flex-row items-center justify-center">
                <div className="max-w-[500px] rounded-3xl overflow-hidden lg:w-[65rem] md:w-[500px] w-full relative lg:h-full h-[300px] bg-cover bg-norepeat bg-center lg:flex-[1]" style={{ backgroundImage: `url('/about-images/about-03.webp')` }}>
                </div>
                <div className={`space-y-3 ${!isFreelance ? '' : 'text-white'} flex flex-col justify-between lg:flex-[1.3]`}>
                    <div className="relative">
                        <div className="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 md:text-[30px] md:leading-[36px] text-[18px] leading-[21px] font-semibold cta-slide-from-bottom">
                            {
                                isFreelance ? 'Vous êtes une entreprise ?' : 'Vous êtes un freelance ?'
                            }
                        </div>
                    </div>
                    <div className="font-semibold md:text-[35px] md:leading-[42px] text-[25px] leading-[30px] cta-slide-from-bottom">
                        {
                            isFreelance ?
                                'Confiez votre projet à Wall of Share ! ' :
                                'Mettez en valeur vos compétences !'
                        }

                    </div>
                    <div className="text-[#ddddf499] font-normal text-md w-10/12 font-dm-sans cta-slide-from-bottom">
                        {
                            isFreelance ? 'Avec Wall of Share, rencontrez le talent qui correspond exactement à votre besoin. Simplifiez votre processus de recrutement et accédez rapidement à des experts prêts à relever vos défis.' :
                                "Rejoignez une communauté d'experts et accédez à des projets qui correspondent à vos compétences. Avec Wall of Share, valorisez votre expertise et trouvez des missions qui vous stimulent."
                        }
                    </div>

                    <div className="pt-1 cta-slide-from-bottom">
                        <RoundBluePlain text="Trouver un freelance" isButton={false} to="/plateforme-freelance" className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" />
                    </div>
                </div>
            </div>
        </div>
    );
}